{
  "pt": {
    "milestone": {
      "actions": {
        "activate": "Ativar",
        "active": "Ativo!",
        "create": "Criar marco",
        "deactivate": "Desativar",
        "delete": "Eliminar",
        "delete_milestones": "Eliminar marco | Eliminar {count} marcos",
        "new": "Marco"
      },
      "activate": {
        "confirm": "Ativar",
        "intro": "Ativar este marco irá:",
        "past_warning": "Voltar a um marco anterior não desfaz as ações já realizadas. Tudo o que foi partilhado com os clientes não será automaticamente revogado.",
        "title": "Ativar marco",
        "verb_default": "Acionar",
        "verb_share": "Partilhar"
      },
      "attach": {
        "add": "Adicionar",
        "add_kind": "Adicionar {kind}",
        "assigned_tag": "Atribuído",
        "back": "Voltar",
        "counts": "{available} disponíveis · {assigned} já atribuídos",
        "description_decision": "Escolhas que o cliente tem de fazer",
        "description_survey": "Questionários para recolher respostas",
        "empty": "Nenhum elemento disponível",
        "empty_state_description": "Consoante o seu plano, pode adicionar {kinds} a este marco.",
        "intro": "Escolha que tipo de elemento pretende associar a este marco.",
        "next": "Seguinte",
        "search": "Pesquisar",
        "select_intro": "Selecione o {kind} que pretende adicionar.",
        "subtitle": "Ao marco: {name}",
        "success": "Elementos adicionados",
        "title": "Adicionar elementos"
      },
      "labels": {
        "add_element": "Adicionar elemento",
        "add_kind": "Adicionar {kind}",
        "assign_units": "Atribuir unidades",
        "assigned_count": "0 atribuído | 1 atribuído | {count} atribuídos",
        "assigned_elements": "Elementos atribuídos",
        "assigned_empty_description": "Anexe {kinds} a este marco",
        "assigned_empty_title": "Ainda não há elementos",
        "bulk_assign_title": "Selecionar as unidades a que pretende atribuir o marco '{milestone_name}'",
        "edit_milestone": "Editar marco",
        "empty_state_subtitle": "As etapas tornam o processo de construção mais transparente para os compradores de casa",
        "empty_state_title": "Criar uma nova etapa",
        "finished_on": "Concluído em {date}",
        "future_milestones": "Marcos futuros",
        "kind_decision": "Decisão | Decisões",
        "kind_survey": "Inquérito | Inquéritos",
        "kind_todo": "Tarefa | Tarefas",
        "milestone": "Marco histórico",
        "milestone_name": "Nome da etapa",
        "milestone_unit_count": "0 unidades | 1 unidade | {count} unidades",
        "milestones": "Marcos históricos",
        "new_milestone": "Novo marco",
        "no_milestone": "Ainda não foi atribuída nenhuma etapa",
        "no_results": "Não foram encontrados marcos",
        "past_milestones": "Marcos anteriores",
        "please_select": "Selecionar uma nova etapa",
        "position": "Posição",
        "search_empty_state": "Ainda não foram criados marcos. Clique aqui para começar",
        "started_on": "Iniciado em {date}",
        "status_active": "Ativo",
        "status_completed": "Concluído",
        "status_planned": "Planeado",
        "status_planned_subtitle": "Ainda não iniciado",
        "unit_timeline_empty": "Ainda não foram criados marcos para este projeto.",
        "units": "Unidades",
        "units_without_milestone": "1 unidade sem marco | {count} unidades sem marco",
        "warning_delete": "Se eliminar uma etapa que tenha sido atribuída a uma unidade, o cliente perderá a noção da etapa em que se encontra a sua unidade. Certifique-se de que atribui uma nova etapa a estas unidades!"
      },
      "toasts": {
        "bulk_assigned": "A etapa é atribuída com êxito às unidades seleccionadas",
        "create_success": "Marco criado com sucesso",
        "deactivate_success": "O marco foi desativado com sucesso",
        "sup_assigned": "A etapa foi activada com êxito",
        "update_success": "Os marcos foram actualizados com sucesso"
      },
      "validation": {
        "needName": "Nome necessário",
        "needNamePrimary": "O nome na língua principal ({language}) é obrigatório"
      }
    }
  }
}
